import React, {
    useState,
    useEffect
} from 'react';


import {
    useSelector,
    useDispatch
} from 'react-redux';


import {
    modificarObjetivoAction
} from '../../actions/objetivosActions';


import useConfigAuth
    from '../../Hooks/useConfigAuth';


// css
import {
    Icon
} from '../Css/StyledHeader';


import {

    KanbanObjetivos,

    ColumnaObjetivos,
    TituloColumnaObjetivos,
    ListaColumnaObjetivos,

    TarjetaObjetivo,
    NombreObjetivoAsignado,

    ControlesObjetivo,
    BotonMoverObjetivo,

    SinObjetivosColumna

} from '../Css/StyledObjetivos';



const ObjetivosAsignados = (
    props
) => {


    const {
        id
    } = props.seccion;


    const dispatch =
        useDispatch();


    const [
        config
    ] = useConfigAuth();


    const [
        disable,
        setDisable
    ] = useState(
        false
    );


    const informacionObjetivos =
        useSelector(
            (state) =>
                state.informacion.info_objetivos
        );


    const id_paciente =
        useSelector(
            (state) =>
                state.usuario.id_paciente
        );


    const [
        objetivosNuevo,
        setObjetivosNuevo
    ] = useState(
        informacionObjetivos
    );


    const [
        objetivoBD,
        setObjetivoBD
    ] = useState(
        []
    );



    /*
    ====================================
    AVANZAR ESTADO
    ====================================
    */

    const avanzarEstado = (
        id_objetivo,
        custom_objetivo,
        id_estado_objetivo
    ) => {


        if (
            id_estado_objetivo ===
            '3'
        ) {

            return;

        }


        let nuevoEstado =
            '';


        switch (
            id_estado_objetivo.toString()
        ) {


            case '1':

                nuevoEstado =
                    '2';

                break;


            case '2':

                nuevoEstado =
                    '3';

                break;


            default:

                break;

        }


        const newList =
            JSON.parse(
                JSON.stringify(
                    objetivosNuevo
                )
            );


        for (
            let i = 0;
            i < newList.length;
            i++
        ) {


            if (
                newList[i].id ===
                    id_objetivo &&
                newList[i].custom ===
                    custom_objetivo
            ) {

                newList[i]
                    .id_estado_objetivo =
                        nuevoEstado;


                setObjetivoBD(
                    newList[i]
                );

            }

        }


        setObjetivosNuevo(
            newList
        );


        setDisable(
            true
        );

    };



    /*
    ====================================
    RETROCEDER ESTADO
    ====================================
    */

    const retrocederEstado = (
        id_objetivo,
        custom_objetivo,
        id_estado_objetivo
    ) => {


        if (
            id_estado_objetivo ===
            '1'
        ) {

            return;

        }


        let nuevoEstado =
            '';


        switch (
            id_estado_objetivo.toString()
        ) {


            case '2':

                nuevoEstado =
                    '1';

                break;


            case '3':

                nuevoEstado =
                    '2';

                break;


            default:

                break;

        }


        const newList =
            JSON.parse(
                JSON.stringify(
                    objetivosNuevo
                )
            );


        for (
            let i = 0;
            i < newList.length;
            i++
        ) {


            if (
                newList[i].id ===
                    id_objetivo &&
                newList[i].custom ===
                    custom_objetivo
            ) {

                newList[i]
                    .id_estado_objetivo =
                        nuevoEstado;


                setObjetivoBD(
                    newList[i]
                );

            }

        }


        setObjetivosNuevo(
            newList
        );


        setDisable(
            true
        );

    };



    /*
    ====================================
    GUARDAR CAMBIO
    ====================================
    */

    useEffect(
        () => {


            if (
                objetivoBD.length ===
                0
            ) {

                return;

            }


            const informacion = {

                config,

                payload: {

                    objetivosNuevo,

                    objetivoBD,

                    id_paciente,

                    tipo:
                        "estado"

                }

            };


            dispatch(
                modificarObjetivoAction(
                    informacion
                )
            );


            setObjetivoBD(
                []
            );


            setTimeout(
                () => {

                    setDisable(
                        false
                    );

                },
                1000
            );


            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            objetivosNuevo
        ]
    );



    /*
    ====================================
    ACTUALIZAR DESDE REDUX
    ====================================
    */

    useEffect(
        () => {


            setObjetivosNuevo(
                informacionObjetivos
            );


        },
        [
            informacionObjetivos
        ]
    );



    /*
    ====================================
    FILTROS
    ====================================
    */

    const objetivosEstablecidos =
        informacionObjetivos.filter(
            objetivo =>

                objetivo
                    .id_seccion_objetivo
                    .toString() ===
                    id.toString() &&

                objetivo
                    .id_etapa_objetivo ===
                    "2" &&

                objetivo
                    .id_estado_objetivo ===
                    "1"
        );


    const objetivosEnProceso =
        informacionObjetivos.filter(
            objetivo =>

                objetivo
                    .id_seccion_objetivo
                    .toString() ===
                    id.toString() &&

                objetivo
                    .id_etapa_objetivo ===
                    "2" &&

                objetivo
                    .id_estado_objetivo ===
                    "2"
        );


    const objetivosFinalizados =
        informacionObjetivos.filter(
            objetivo =>

                objetivo
                    .id_seccion_objetivo
                    .toString() ===
                    id.toString() &&

                objetivo
                    .id_etapa_objetivo ===
                    "2" &&

                objetivo
                    .id_estado_objetivo ===
                    "3"
        );



    return (

        <KanbanObjetivos>


            {/*
            ====================================
            OBJETIVOS ESTABLECIDOS
            ====================================
            */}


            <ColumnaObjetivos>


                <TituloColumnaObjetivos>

                    Objetivos establecidos

                </TituloColumnaObjetivos>


                <ListaColumnaObjetivos>


                    {
                        objetivosEstablecidos.length ===
                        0
                            ?

                            <SinObjetivosColumna>

                                Todavía no hay objetivos establecidos.

                            </SinObjetivosColumna>

                            :

                            objetivosEstablecidos.map(
                                objetivo => (

                                    <TarjetaObjetivo

                                        key={
                                            `${objetivo.id}-${objetivo.custom}`
                                        }

                                    >


                                        <NombreObjetivoAsignado>

                                            {
                                                objetivo.nombre_objetivo
                                            }

                                        </NombreObjetivoAsignado>


                                        <ControlesObjetivo>


                                            <BotonMoverObjetivo

                                                disabled={
                                                    disable
                                                }

                                                type="button"

                                                title={
                                                    "Mover a En proceso"
                                                }

                                                onClick={
                                                    () =>
                                                        avanzarEstado(
                                                            objetivo.id,
                                                            objetivo.custom,
                                                            objetivo.id_estado_objetivo
                                                        )
                                                }

                                            >


                                                <Icon

                                                    src={
                                                        `/img/flechaDerecha.png`
                                                    }

                                                    alt={
                                                        "Derecha"
                                                    }

                                                    width={
                                                        "15px"
                                                    }

                                                    height={
                                                        "15px"
                                                    }

                                                />


                                            </BotonMoverObjetivo>


                                        </ControlesObjetivo>


                                    </TarjetaObjetivo>

                                )
                            )
                    }


                </ListaColumnaObjetivos>


            </ColumnaObjetivos>


            {/*
            ====================================
            EN PROCESO
            ====================================
            */}


            <ColumnaObjetivos>


                <TituloColumnaObjetivos>

                    En proceso

                </TituloColumnaObjetivos>


                <ListaColumnaObjetivos>


                    {
                        objetivosEnProceso.length ===
                        0
                            ?

                            <SinObjetivosColumna>

                                Todavía no hay objetivos en proceso.

                            </SinObjetivosColumna>

                            :

                            objetivosEnProceso.map(
                                objetivo => (

                                    <TarjetaObjetivo

                                        key={
                                            `${objetivo.id}-${objetivo.custom}`
                                        }

                                    >


                                        <NombreObjetivoAsignado>

                                            {
                                                objetivo.nombre_objetivo
                                            }

                                        </NombreObjetivoAsignado>


                                        <ControlesObjetivo>


                                            <BotonMoverObjetivo

                                                disabled={
                                                    disable
                                                }

                                                type="button"

                                                title={
                                                    "Volver a Objetivos establecidos"
                                                }

                                                onClick={
                                                    () =>
                                                        retrocederEstado(
                                                            objetivo.id,
                                                            objetivo.custom,
                                                            objetivo.id_estado_objetivo
                                                        )
                                                }

                                            >


                                                <Icon

                                                    src={
                                                        `/img/flechaIzquierda.png`
                                                    }

                                                    alt={
                                                        "Izquierda"
                                                    }

                                                    width={
                                                        "15px"
                                                    }

                                                    height={
                                                        "15px"
                                                    }

                                                />


                                            </BotonMoverObjetivo>


                                            <BotonMoverObjetivo

                                                disabled={
                                                    disable
                                                }

                                                type="button"

                                                title={
                                                    "Mover a Finalizados"
                                                }

                                                onClick={
                                                    () =>
                                                        avanzarEstado(
                                                            objetivo.id,
                                                            objetivo.custom,
                                                            objetivo.id_estado_objetivo
                                                        )
                                                }

                                            >


                                                <Icon

                                                    src={
                                                        `/img/flechaDerecha.png`
                                                    }

                                                    alt={
                                                        "Derecha"
                                                    }

                                                    width={
                                                        "15px"
                                                    }

                                                    height={
                                                        "15px"
                                                    }

                                                />


                                            </BotonMoverObjetivo>


                                        </ControlesObjetivo>


                                    </TarjetaObjetivo>

                                )
                            )
                    }


                </ListaColumnaObjetivos>


            </ColumnaObjetivos>


            {/*
            ====================================
            FINALIZADOS
            ====================================
            */}


            <ColumnaObjetivos>


                <TituloColumnaObjetivos>

                    Finalizados

                </TituloColumnaObjetivos>


                <ListaColumnaObjetivos>


                    {
                        objetivosFinalizados.length ===
                        0
                            ?

                            <SinObjetivosColumna>

                                Todavía no hay objetivos finalizados.

                            </SinObjetivosColumna>

                            :

                            objetivosFinalizados.map(
                                objetivo => (

                                    <TarjetaObjetivo

                                        key={
                                            `${objetivo.id}-${objetivo.custom}`
                                        }

                                    >


                                        <NombreObjetivoAsignado>

                                            {
                                                objetivo.nombre_objetivo
                                            }

                                        </NombreObjetivoAsignado>


                                        <ControlesObjetivo>


                                            <BotonMoverObjetivo

                                                disabled={
                                                    disable
                                                }

                                                type="button"

                                                title={
                                                    "Volver a En proceso"
                                                }

                                                onClick={
                                                    () =>
                                                        retrocederEstado(
                                                            objetivo.id,
                                                            objetivo.custom,
                                                            objetivo.id_estado_objetivo
                                                        )
                                                }

                                            >


                                                <Icon

                                                    src={
                                                        `/img/flechaIzquierda.png`
                                                    }

                                                    alt={
                                                        "Izquierda"
                                                    }

                                                    width={
                                                        "15px"
                                                    }

                                                    height={
                                                        "15px"
                                                    }

                                                />


                                            </BotonMoverObjetivo>


                                        </ControlesObjetivo>


                                    </TarjetaObjetivo>

                                )
                            )
                    }


                </ListaColumnaObjetivos>


            </ColumnaObjetivos>


        </KanbanObjetivos>

    );

};


export default ObjetivosAsignados;